"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGOUT_FAILURE = exports.LOGOUT_SUCCESS = exports.LOGOUT_REQUEST = exports.LOGIN_FAILURE = exports.LOGIN_SUCCESS = exports.LOGIN_REQUEST = void 0;
exports.LOGIN_REQUEST = 'session/login/REQUEST';
exports.LOGIN_SUCCESS = 'session/login/SUCCESS';
exports.LOGIN_FAILURE = 'session/login/FAILURE';
exports.LOGOUT_REQUEST = 'session/logout/REQUEST';
exports.LOGOUT_SUCCESS = 'session/logout/SUCCESS';
exports.LOGOUT_FAILURE = 'session/logout/FAILURE';
//# sourceMappingURL=types.js.map